import styled from "styled-components";

export const StyledMainChartContainer = styled.div`
  display: ${(props) => (props.show ? "" : "none")};
  flex: 1 1 auto;
  min-width: 580px;
  max-height: calc(100vh - 50px);
`;
